import { memo } from "react";
import _ from "lodash";
import UserLocationItem from "./UserLocationItem";

const UserLocations = ({ mapRef, hoverTimeout, mapContainerRef, userLocations }) => {

  return (
    <>
      {userLocations.map((item) => (
        <UserLocationItem
          hoverTimeout={hoverTimeout}
          key={item.id}
          userData={item}
          mapRef={mapRef}
          mapContainerRef={mapContainerRef}
        />
      ))}
    </>
  );
};

export default memo(UserLocations);
